import { render, staticRenderFns } from "./BetonConfig.vue?vue&type=template&id=43df6906&scoped=true"
import script from "./BetonConfig.vue?vue&type=script&lang=js"
export * from "./BetonConfig.vue?vue&type=script&lang=js"
import style0 from "./BetonConfig.vue?vue&type=style&index=0&id=43df6906&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43df6906",
  null
  
)

export default component.exports